import useModals from "./useModals"
import CreateModal from "web/components/CreateModal/CreateModal"
import { titleize } from "web/services/inflector"

export default function useDialogModal() {
  const { showModal } = useModals()
  const modalProps = {
    fullScreen: false,
    heightPixels: 250,
    widthPixels: 600,
  }

  return async function ({ kind, collection, addParams }) {
    return await showModal({
      ...modalProps,
      title: `Add ${titleize(kind)}`,
      component: ({ respond }) => (
        <CreateModal
          kind={kind}
          collection={collection}
          addParams={addParams}
          respond={respond}
        />
      ),
    })
  }
}
